module.exports = __webpack_public_path__ + "img/background.a5a6f0f0.png";